// extracted by mini-css-extract-plugin
module.exports = {"sidebarList":"sidebarList-module--sidebarList--C4qf7","fontsLoading":"sidebarList-module--fonts-loading--sQS_2"};